<script setup lang="ts">
import type { RelatedTagsParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  title?: string
  tags?: RelatedTagsParagraph['relatedTags']['tags']
}>()
</script>

<template>
  <div class="bx-content bx-tags bx-typo--tags">
    <span v-if="title"
          class="bx-tags__headline">
      {{ title }}
    </span>
    <template v-for="(tag, index) in tags ?? []">
      <a v-if="tag.url && tag.url.length > 0"
         :key="`${index}-url`"
         :href="tag.url"
         class="bx-tags__tag">
        {{ tag.name }}
      </a>
      <span v-else
            :key="index"
            class="bx-tags__tag">
        {{ tag.name }}
      </span>
    </template>
  </div>
</template>
